function normalizeText(value) {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
}

function validateFollowupSubmission({ followUpSuggestion, reviewDueDate } = {}) {
  if (!normalizeText(followUpSuggestion)) {
    return { error: '请选择随诊建议', requiresTermination: false };
  }
  return {
    error: null,
    requiresTermination: !reviewDueDate
  };
}

function normalizeTerminationReason(value) {
  return normalizeText(value);
}

function getFollowupDialogTitle({ mode, isRead } = {}) {
  if (isRead) return '随访详情';
  return mode === 'reviewNotification' ? '复查通知' : '一键随访';
}

function buildReadonlyFollowupDetail(detail = {}) {
  return {
    form: { ...detail },
    userInfos: {
      realName: detail.followupDoctor || detail.operator || '',
      deptName: detail.followupDept || detail.department || '',
      hospitalName: detail.followupHospital || '',
      phone: detail.followupPhone || '',
      followupTime: detail.followupTime || null
    }
  };
}

function buildFollowupSubmission({ patient = {}, form = {}, userInfos = {}, terminationReason = null } = {}) {
  return {
    idcard: patient.idcard,
    currentTaskId: patient.id || null,
    managementTag: form.managementTag,
    surgeryStatus: form.surgeryStatus,
    pathologicalType: form.pathologicalType,
    followUpSuggestion: form.followUpSuggestion,
    reviewDueDate: form.reviewDueDate,
    reviewFlag: form.reviewDueDate ? 1 : 0,
    terminationReason,
    remarks: form.remarks,
    phoneResult: form.phoneResult,
    patientCompliance: form.patientCompliance,
    patientIntention: form.patientIntention,
    annotation: form.annotation,
    followupDoctor: userInfos.name,
    followupDept: userInfos.deptName,
    followupHospital: userInfos.hospitalName,
    followupPhone: userInfos.hospitalPhone,
    followupTime: userInfos.codiagTime,
  };
}

function displayFollowupValue(value) {
  if (value == null || String(value).trim() === '') return '-';
  return value;
}

function displayGender(value) {
  if (value == null || String(value).trim() === '') return '-';
  const gender = String(value).trim();
  if (gender === '1') return '男';
  if (gender === '2') return '女';
  return gender;
}

module.exports = {
  validateFollowupSubmission,
  normalizeTerminationReason,
  getFollowupDialogTitle,
  buildReadonlyFollowupDetail,
  buildFollowupSubmission,
  displayFollowupValue,
  displayGender
};
